import { render } from "./UploadDocumentsComponent.vue?vue&type=template&id=ebfaad60"
import script from "./UploadDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./UploadDocumentsComponent.vue?vue&type=script&lang=js"

import "./UploadDocumentsComponent.vue?vue&type=style&index=0&id=ebfaad60&lang=css"
script.render = render

export default script